import {useServerTime} from '@glark-newco/game-library';
import dayjs, {Dayjs} from 'dayjs';
import {useMemo} from 'react';
import {crunchTimeTransitionDuration, useCrunchTime} from './useCrunchTime';
import {useGameCompletion} from './useGameCompletion';

export const useGameOver = (): {
    isGameOver: boolean,
    gameOverTime: Dayjs | null,
} => {
    const {isCrunchTime, crunchTimeStartTime, crunchTimeDurationMs} = useCrunchTime();
    const {isComplete} = useGameCompletion();
    const serverTime = useServerTime();

    // When CrunchTime will end, or time when the game was solved.
    const gameOverTime = useMemo(() => {
        if (!crunchTimeStartTime) { return null; }
        return dayjs(crunchTimeStartTime)
            .add(crunchTimeTransitionDuration, 'milliseconds')
            .add(isComplete ? 0 : crunchTimeDurationMs, 'milliseconds');
    }, [crunchTimeStartTime, isComplete]);

    const isGameOver = useMemo(() => {
        if (!serverTime || !gameOverTime) {
            return false;
        }
        return isCrunchTime && serverTime.isAfter(gameOverTime);
    }, [serverTime, gameOverTime, isCrunchTime, isComplete]);

    // console.debug(`useGameOver isCrunchTime: ${isCrunchTime}, isComplete: ${isComplete}, gameOverTime: ${gameOverTime?.toISOString()}, serverTime: ${serverTime?.toISOString()}`)
    return {isGameOver, gameOverTime};
};